<!--
 * @Description: 群活码
 * @Author: yuxin
 * @Date: 2025-07-29 14:08:34
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-08-18 17:45:39
 * @FilePath: \mgr_web\src\views\group\groupActiveCode.vue
-->

<template>
  <div class="groupActiveCode-container">
    <div class="search-wrap">
      <el-form inline>
        <el-form-item label="活码名称：">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入名称"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="使用场景：">
          <el-input
            v-model="searchParams.sceneName"
            placeholder="请输入使用场景"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="selectBindStatus"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="创建人：">
          <el-input
            v-model="searchParams.creatorName"
            size="mini"
            clearable
            @change="selectBindStatus"
            placeholder="请输入创建人"
          />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="searchParams.status"
            placeholder="请选择"
            size="mini"
            @change="selectBindStatus"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="可用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
            <el-option label="失效" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="toStaffLabel" type="primary"
            >标签管理</el-button
          >
          <el-button size="mini" @click="addActiveCode" type="primary"
            >新建活码</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      fit
      highlight-current-row
      align="center"
      :header-cell-style="{ background: '#eef1f6' }"
      ref="cusChatTable"
      height="calc(100vh - 350px)"
    >
      <el-table-column
        prop="name"
        label="活码名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="creatorName" label="创建人" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
        <template slot-scope="scope">
          {{ getfTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="sceneName" label="使用场景" align="center">
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span style="color:#81bcfd" v-if="scope.row.status == 1">可用</span>
          <span style="color:#fdd554" v-if="scope.row.status == 0">停用</span>
          <span style="color:#ff6464" v-if="scope.row.status == -1">失效</span>
        </template>
      </el-table-column>

      <el-table-column prop="operation" label="操作" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            class="operation-btn"
            @click="handleDownloadActiveCode(scope.row)"
            v-if="scope.row.status == 1"
          >
            <span v-show="!scope.row.download">下载</span>
            <span v-show="scope.row.download">下载中...</span>
          </el-link>
          <el-link
            :underline="false"
            type="primary"
            class="operation-btn"
            @click="goEdit(scope.row)"
            >编辑</el-link
          >
          <el-link
            :underline="false"
            type="warning"
            class="operation-btn"
            @click="handleEnableOrStopActiveCode(scope.row)"
            v-if="scope.row.status != -1"
            >{{ scope.row.status == 1 ? "停用" : "启用" }}</el-link
          >
          <el-link
            :underline="false"
            type="danger"
            @click="handleDeleActiveCode(scope.row)"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="staff-pagination">
      <el-pagination
        @current-change="currentChange"
        @size-change="sizeChange"
        :current-page.sync="searchParams.page"
        :page-size.sync="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchParams.total"
        :page-sizes="[20, 50, 100, 200, 500]"
      >
      </el-pagination>
    </div>
    <!-- <Pagination
      v-bind:childMsg="pageparm.pageNum"
      :pageSizes="pageparm.size"
      @callBack="callBack"
    ></Pagination> -->

    <!-- 新增活码组件 -->
    <AddActiveCode
      ref="AddActiveCodeRef"
      v-if="addActiveCodeShow"
      @addAndEditClose="addAndEditClose"
    />
  </div>
</template>
<script>
import AddActiveCode from "./components/addActiveCode.vue";
import { activityTagType } from "@/api/activeCode/activeCode.js";
import { timeFormat } from "@/utils/common.js";
import {
  /** 列表 */
  groupQrCodeListApi,
  /** 启用/禁用 */
  updateStateApi,
  /** 删除 */
  removeApi,
  /** 下载 */
  downloadQrCodeApi,
} from "@/api/group/code.js";
import dayjs from "dayjs";
export default {
  name: "groupCode",
  components: {
    AddActiveCode,
  },
  data() {
    return {
      /** 存储群活码列表 */
      tableData: [],
      /** 分页数据 */
      pageparm: {
        pageNum: 1,
        pageSize: 20,
        total: 10,
      },
      /** 搜索参数 */
      searchParams: {
        total: 0,
        /** 排序字段 */
        sort: "",
        /** 是否降序 */
        asc: false,
        /** 页面码 */
        page: 1,
        /** 每页条数 */
        size: 20,
        /** 群活码名称 */
        name: "",
        /** 进群方式 1 - 直接进群 2 - 好友进群 */
        // joinWay: "",
        /** 使用场景 */
        sceneName: "",
        /** 创建人 */
        creatorName: "",
        /** 状态 1:启用 0:禁用 */
        status: "",
        /** 使用员工 */
        // staffName: "",
        /** 创建开始时间 */
        startTime: "",
        /** 创建结束时间 */
        endTime: "",
      },
      /** 分页条数 */
      pageSizes: [20, 50, 100, 200, 500],
      date: null,
      /** 禁止选中未来日期 */
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      /** 禁止选中过去时间 */
      expirationTimePickerOptions: {
        disabledDate(time) {
          // 禁用今天之前的所有日期（不含今天）
          return time.getTime() < Date.now() - 8.64e7; // 8.64e7 = 24小时毫秒数
        },
      },
      /** 新增/编辑弹框显示隐藏 */
      addActiveCodeShow: false,
    };
  },
  methods: {
    /** 获取群活码列表数据 */
    getList() {
      // this.pageparm.pageNum = this.searchParams.page;
      // this.pageparm.pageSize = this.searchParams.size;
      console.log("SDfsdfsdfsd", this.pageparm.page);
      groupQrCodeListApi(
        this.searchParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res && res.error && res.error.code == 200) {
          if (res.data.records.length > 0) {
            this.tableData = res.data.records;
            this.searchParams.total = Number(res.data.total);

            // this.total = res.data.total
          } else {
            this.tableData = [];
            this.searchParams.total = 0;
          }
        }
      });
    },

    /** 点击启用或停用群活码 */
    handleEnableOrStopActiveCode(row) {
      // const tipText =
      //   row.status == 1
      //     ? ""
      //     : "确认停用当前活码？停用后，已下载的活码不受影响，不再支持下载新活码";
      if (row.status == 1) {
        this.$confirm(
          "确认停用当前活码？停用后，已下载的活码不受影响，不再支持下载新活码",
          "提示",
          {
            confirmButtonText: "确定停用",
            cancelButtonText: "我再想想",
            type: "warning",
          }
        ).then(() => {
          const requestParams = {
            /** 主键id */
            id: row.id,
            /** 启用状态,示例值(1:启用 0:禁用) */
            status: 0,
          };
          /** 调用接口
           *
           */
          updateStateApi(
            requestParams,
            localStorage.getItem("Authorization")
          ).then((res) => {
            if (res && res.error && res.error.code == 200) {
              this.$message.closeAll();
              this.$message.success("操作成功");
              this.getList();
            }
          });
        });
      } else {
        const requestParams = {
          /** 主键id */
          id: row.id,
          /** 启用状态,示例值(1:启用 0:禁用) */
          status: 1,
        };
        /** 调用接口
         *
         */
        updateStateApi(
          requestParams,
          localStorage.getItem("Authorization")
        ).then((res) => {
          if (res && res.error && res.error.code == 200) {
            this.$message.success("启用成功！");
            this.getList();
          }
        });
      }
    },

    /** 点击删除按钮触发 */
    handleDeleActiveCode(row) {
      this.$confirm("确认删除当前活码？删除后，已下载的活码不受影响", "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "我再想想",
        type: "warning",
      }).then(() => {
        removeApi(row.id, localStorage.getItem("Authorization")).then((res) => {
          if (res && res.error && res.error.code == 200) {
            this.$message.success("操作成功");
            this.getList();
          }
        });
      });
    },

    /** 下载活码 */
    handleDownloadActiveCode(row) {
      this.$confirm("确定下载吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        /** 触发下载方法 */
        this.downloadHandle(row);
      });
    },

    // 下载
    downloadHandle(row, index) {
      let urlIt = `/api/qywechat/groupCode/downloadQrCode?id=${row.id}`; //下载接口
      /** 图片名称&文件名 */
      let fileName = `${row.name}.png`;
      let $t = this;
      let flagTableData = JSON.parse(JSON.stringify($t.tableData));
      for (let i = 0; i < flagTableData.length; i++) {
        if (flagTableData[i].id == row.id) {
          flagTableData[i].download = true;
          break;
        }
      }
      $t.tableData = flagTableData;
      this.$http({
        method: "get",
        url: this.$baseUrl + urlIt, //this.domainName 是域名  比如：http://192.168.2.160:8080
        responseType: "blob",
        headers: {
          authorization: localStorage.getItem("Authorization"),
        },
      }).then(function(response) {
        console.log(456, response);
        let flagTableArr = JSON.parse(JSON.stringify($t.tableData));
        for (let i = 0; i < flagTableArr.length; i++) {
          if (flagTableArr[i].id == row.id) {
            flagTableArr[i].download = false;
            break;
          }
        }
        $t.tableData = flagTableArr;
        if (response.data.type === "application/octet-stream") {
          //获取http头部的文件名信息，若无需重命名文件，将下面这行删去
          //兼容ie内核，360浏览器的兼容模式
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([response.data]);
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            //火狐谷歌的文件下载方式
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a"); // 创建a标签
            link.href = url;
            link.download = fileName; // 文件重命名，若无需重命名，将该行删去
            link.click();
            URL.revokeObjectURL(url); // 释放内存
          }
        } else {
          $t.$message("下载错误");
        }
      });
    },

    /** 跳转到标签管理 */
    toStaffLabel() {
      this.$router.push("/code/StaffLabel");
    },

    /** 点击新建设活码触发 */
    addActiveCode() {
      this.addActiveCodeShow = true;
      this.$nextTick(() => {
        this.$refs.AddActiveCodeRef.init();
      });
      // this.dialogVisible = true;
    },

    /** 创建时间变化触发 */
    selectBindStatus() {
      if (this.date != null) {
        this.searchParams.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.searchParams.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.searchParams.startTime = "";
        this.searchParams.endTime = "";
      }
      this.searchParams.page = 1;
      this.getList();
    },

    /** 分页条数 */
    callBack(parm) {
      this.searchParams.page = parm.currentPage;
      this.searchParams.size = parm.pageSize;
      // this.loading = true;
      this.getList();
    },

    /** 禁止选择今天以后的日期 */
    disabledDate(time) {
      return time.getTime() > Date.now();
    },

    /** 格式化时间 */
    getfTime(time) {
      return timeFormat(time, "yyyy:mm:dd hh:MM:ss");
    },

    /** 新增或编辑弹窗关闭触发 */
    addAndEditClose(e) {
      console.log("有没有触发呢？？？？");
      this.addActiveCodeShow = false;
      if (e) {
        this.getList();
      }
    },

    /** 点击编辑触发 */
    goEdit(row) {
      this.addActiveCodeShow = true;
      this.$nextTick(() => {
        this.$refs.AddActiveCodeRef.init(row);
      });
    },
    /** 页码改变回调 */
    currentChange(parm) {
      console.log("sdfsdfsdfdfgtre", parm);
      this.searchParams.page = parm;

      this.getList();
    },

    /** 页数改变回调 */
    sizeChange(parm) {
      console.log("sdfsdfsdfdfgtre1", parm);
      this.searchParams.pageSize = parm;

      this.getList();
    },
  },

  /** 生命周期 */
  updated() {
    this.$nextTick(() => {
      this.$refs["cusChatTable"].doLayout();
    });
  },

  created() {
    /** 获取活码列表 */
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.groupActiveCode-container {
  // height: 100%;
  // width: 100%;
  .search-wrap {
  }
  .el-link.el-link--default {
    margin: 0 5px;
    color: "#699eff";
  }
  .operation-btn {
    margin-right: 10px;
  }
  .staff-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
}
</style>
